"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  stockBase: {
    common: {
      meterialBaseData: 'Material base data',
      operation: 'Operation',
      cancel: 'Invalid',
      copyAdd: 'Copy the new',
      baseData: 'Base Data'
    },
    keyWordFilter: {
      mat: 'Can query template code, template name'
    },
    materialApplyTem: {
      maTemplate: 'Material Requisition Template',
      maTemplateAdd: 'Material application template has been adde',
      maTemplateEdit: 'Material application template editing',
      company: 'Company',
      shipName: 'Vessel Name',
      applyCategory: 'Apply Type',
      temCode: 'Template Code',
      tempNameEN: 'Template Name(En)',
      tempName: 'Template Name(Cn)',
      creator: 'Creator',
      createDept: 'Create Dept',
      state: 'State',
      remark: 'Remark',
      unEffective: 'Unsubmitted',
      effective: 'Submitted',
      voided: 'Invalid',
      allTemp: 'All',
      sequence: 'Sequence No',
      IMPACode: 'IMPA code',
      materiaName: 'Material Name',
      materialSize: 'Material Spec',
      unit: 'Unit',
      dAQty: 'Default Apply Num',
      baseInfo: 'Base Info',
      fileInfo: 'Attachment',
      mtrMsg: 'Material Info',
      spanContent: 'Colored Numbers: The quantity requested is not consistent with the order quantity',
      chooseAppMtr: 'Select materials to apply for',
      material: 'Material',
      rules: {
        companyReq: 'Please select company',
        typeReq: 'Please select category'
      }
    },
    purchaseHome: {
      spsManage: 'Spare Manage',
      mtrManage: 'Material Manage',
      urgentNum: 'Urgency',
      orderTracking: 'Order Tracking',
      supplierName: 'Supplier Name',
      logtName: 'Logistics Name',
      ateTime: 'Estimated time of delivery',
      atePort: 'Expected port of delivery',
      orderNum: 'Order No',
      payState: 'Payment Status',
      state: 'State',
      budgetPerformance: 'Budget Performance',
      annualFleetBbudget: 'AnnualFleet Budget',
      rBAFleet: 'The remaining budget amount of the fleet',
      actualUseFleet: 'The actual amount used by the fleet',
      notOrderedFleet: 'Amount of fleet orders not placed',
      comparisonAllShip: 'Comparison of ships in charge',
      comparisonShip: 'Fleet contrast',
      shipName: 'Vessel Name',
      costSub: 'budget account',
      annualBudget: 'Budget amount',
      hint: 'Please select a record',
      actualUse: 'Order Amount',
      actualProportion: 'Budget completion progress',
      notOrderAmount: 'Unplaced order amount',
      payAttentionDoc: 'Collection of documents',
      docNo: 'Document no.',
      docType: 'Document type ',
      businessMode: 'Business module',
      businessSummary: 'Business in this paper',
      remark: 'Remark',
      spsMinStocky: 'Minimum stock warning',
      keyParts: 'Key Parts',
      optParts: 'Operational parts',
      monParts: 'controlled parts',
      items: '(items)',
      optStock: 'operating inventory',
      notStockyNum: 'Quantity out of stock',
      stockyChange: 'Inventory changes',
      currentDay: 'On the day',
      sevenDay: 'In recent 7',
      thirtyDay: 'In recent 30',
      inStockyNum: 'Warehouse number',
      outStockyNum: 'Number of outbound',
      inventoryMonitor: 'Last stock count',
      inventoryOrderNo: 'Inventory number',
      inventoryOrderTime: 'Inventory date',
      inventoryGainLoss: 'Transaction gain/loss',
      currentState: 'Current State',
      spsMinStockyWarning: 'Minimum inventory warning for spare parts',
      index: 'Index',
      equipmentMsg: 'Equipment Info',
      spsMsg: 'Spare Info',
      minStocky: 'Min Stocky',
      currentStocky: 'Current Stocky',
      mtrMinStockyWarning: 'Minimum inventory of materials early warning',
      mtrType: 'Material Category',
      mtrMsg: 'Material Info',
      drugMsg: 'Drug Info',
      num: 'Num',
      validWaring: 'Validity warning',
      category: 'Category',
      manufactureDate: 'Date of production',
      expirationDate: 'Expiration date',
      Expired: 'Distance validity period (days)',
      stockyWarning: 'Stock count warning',
      lastCountDate: 'Date of last inventory',
      daysFromLastCount: 'Days since last count',
      quickCheck: 'Quick inventory',
      quickSign: 'Quick to sign for',
      spare: 'Spare',
      material: 'Material',
      apply: 'Apply',
      spsApply: 'Spare Apply',
      mtrApply: 'Material Apply',
      inOutStocky: 'In Out Stocky',
      spsInOutStocky: 'Sps In Out Stocky',
      mtrInOutStocky: 'Mtr In Out Stocky',
      inventory: 'Inventory',
      spsInventory: 'Sps Inventory',
      mtrInventory: 'Mtr Inventory',
      defectiveMark: 'Defective Mark',
      spsDefectiveMark: 'Sps Defective Mark',
      mtrDefectiveMark: 'Mtr Defective Mark',
      signFor: 'Sign For',
      spsSignFor: 'Sps Sign For',
      mtrSignFor: 'Mtr Sign For',
      addEvaluation: 'Add Evaluation',
      spsAddEvaluation: 'Sps Add Evaluation',
      mtrAddEvaluation: 'Mtr Add Evaluation',
      flowManagement: 'Flow Management',
      spsFlowManagement: 'Sps Flow Management',
      mtrFlowManagement: 'Mtr Flow Management',
      harmFulList: 'Harm Ful List',
      spsHarmFulList: 'Sps Harmful List',
      mtrHarmFulList: 'Mtr Harmful List',
      spsOrderSignFor: 'Sps Order SignFor',
      dept: 'Dept',
      applyNo: 'Apply No',
      equipmentName: 'Equipment Name',
      orderedDate: 'Ordered Date',
      supplier: 'Supplier',
      logisticsProvider: 'Logistics Provider',
      mtrOrderSignFor: 'Mtr Order SignFor'
    },
    locationInfo: {
      locationInfo: 'Location Info',
      changeStock: 'Change Stock',
      vesselName: 'Vessel Name',
      parentLocation: 'Parent Location',
      code: 'Code',
      personInCharge: 'Person In Charge',
      locationName: 'Location Name',
      operator: 'Operator',
      locationNameEn: 'Location Name En',
      operateDate: 'Operate Date',
      locationDesc: 'Location Desc',
      locationDescEn: 'Location Desc En',
      locationAddTip: 'Please click spare location or Store location to select the type of location to be added'
    },
    materialStock: {
      materialStock: 'Material Stock',
      printBarcode: 'Print Barcode',
      seqNo: 'NO.',
      materialCode: 'Material Code',
      materialType: 'Material Type',
      applyType: 'Apply Type',
      materialName: 'Material Name',
      materialNameEn: 'Material Name En',
      saveTip: 'English name + specification model must be unique',
      spec: 'Spec',
      specEn: 'Spec En',
      unit: 'Unit',
      status: 'Status',
      canApply: 'Can Apply',
      safetyFlag: 'Safety Flag',
      remark: 'Remark',
      opt: 'Operation',
      materialInfo: 'Material Info',
      showMaterialInfo: 'View material details',
      materialInventoryTips: 'To view the history of material purchase and material inventory change, please select the ship first',
      manageImage: 'Manage Image',
      imageManage: 'Image Manage',
      monitorFlag: 'Monitor Flag',
      blindFlag: 'Blind Flag',
      criticalFlag: 'Critical Flag',
      harmfulFlag: 'Harmful Flag',
      proposedPrice: 'Proposed Price',
      proposedPriceCurrency: 'Proposed Price Currency',
      vesselSetting: 'Vessel Setting',
      filterTip: 'Filter Tip',
      batchSetting: 'Batch Setting',
      vesselCode: 'Vessel Code',
      vesselName: 'Vessel Name',
      oilPurpose: 'Oil Purpose',
      minStockQty: 'Min StockQty',
      maxStockQty: 'Max StockQty',
      stockSetting: 'Stock Setting',
      oilTip: 'Only one use of a single lubricating oil is associated with the inventory, the associated inventory of lubricating oil consumption in the monthly report will produce the outbound record, the type of lubricating oil in a single lubricating oil is consistent.',
      addPurpose: 'Add Purpose',
      linkStock: 'Link Stock',
      oilType: 'Oil Type',
      purposeName: 'Purpose Name',
      tankCapacity: 'Tank Capacity',
      density: 'Density',
      useVessel: 'Use Vessel',
      vesselNameCn: 'Vessel NameCn',
      vesselNameEn: 'Vessel NameEn',
      uploadImage: 'Upload Image',
      imageInfo: 'Image Info',
      fileName: 'File Name',
      uploadTime: 'Upload Time',
      sort: 'Sort',
      sequence: 'Sequence',
      effective: 'Effective',
      all: 'All',
      invalided: 'Invalided',
      newStock: 'New Stock',
      editStock: 'Edit Stock',
      vessel: 'Vessel',
      purchaseHistory: 'Purchase History',
      stockChange: 'Stock Change',
      companyInfoTip: 'Please fill in the company configuration information',
      companyInfoSelectTip: 'Select the company information in the company configuration',
      currentMaterialToSave: 'Materials currently stored',
      sameTips1: 'The materials to be saved are similar to the following materials. Do you want to save them?'
    },
    materialType: {
      materialType: 'Material Type',
      materialTypeCode: 'Material Type Code',
      parentType: 'Parent Type',
      sequence: 'Sequence',
      materialTypeName: 'Material Type Name',
      materialTypeNameEn: 'Material Type NameEn',
      materialTypeDesc: 'Material Type Desc',
      materialTypeDescEn: 'Material Type DescEn',
      remark: 'Remark'
    }
  }
};